var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.loading)?_c('div',{staticClass:"cont"},[_c('div',{staticClass:"dash uno"}),_c('div',{staticClass:"dash dos"}),_c('div',{staticClass:"dash tres"}),_c('div',{staticClass:"dash cuatro"})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }